import React, { Component } from 'react';

//import SupportCard from './Cards/SupportCard';
import CalendarRemoteCard from './Cards/CalendarRemoteCard';
import CalendarVacationCard from './Cards/CalendarVacationCard';
import CalendarReleaseCard from './Cards/CalendarReleaseCard';
import VersionCard from './Cards/VersionCard';
import MeetingRoomCard from './Cards/MeetingRoomCard';
import Carousel from './DownCarousel';
import { CARDS_PER_ROW } from '../constants';

/**
 * Displays array of items inside `row-contents` based on a given limit
 *
 * @param {Array}  items The items to display.
 * @param {Number} limit The limit set to create a new `row-content`
 */
const DisplayRows = (items, limit = CARDS_PER_ROW) => {
    const rows = [];

    for (var i = 0; i < items.length; i += limit) {
        rows.push(items.slice(i, i + limit));
    }

    return rows.map((row, index) => (
        <div className="row" key={index}>
            <div className="row-content">{row.map(item => item)}</div>
        </div>
    ));
};

class AppContent extends Component {
    render() {
        return (
            <div className="content">
                {DisplayRows([
//                    <SupportCard title="Support issues" key="support-card" />,
                    <VersionCard key="version-card" />,
                    <CalendarRemoteCard key="calendar-remote-card" />,
                    <CalendarVacationCard key="calendar-vacation-card" />,
                    <CalendarReleaseCard key="calendar-release-card" />,
                    <MeetingRoomCard key="meeting-room-card" />

                ])}
                {DisplayRows([
                    <Carousel key="carousel"/>
                ])}
            </div>
        );
    }
}

export { AppContent };



// WEBPACK FOOTER //
// ./src/components/AppContent.js